<flx-test-modal
  [previewMode]="previewMode()"
  [title]="title()"
  [sections]="sections()"
  (testModalClose)="onClose()"
>
  <ng-container leftSection>
    <flx-scripting-input-data
      [processDefinitionName]="processDefinitionName()"
      [(data)]="inputString"
      class="grow"
    />
  </ng-container>
  <ng-container middleSection>
    <flx-scripting-edit
      [autocompleteOptions]="autoCompleteOptions"
      [showTabs]="true"
      [readonly]="readonly()"
      [conversationTargetDescriptor]="conversationTargetDescriptor()"
      [contextType]="type()"
      [enableAiActions]="showAiActions()"
      [saveButtonLabel]="saveButtonLabel()"
      (save)="onSave($event)"
      (run)="onRun($event)"
      (previewModeChange)="onPreviewModeChange($event)"
      [(code)]="expression"
      class="grow min-h-0"
    />
  </ng-container>
  <ng-container rightSection>
    <flx-scripting-output
      [condition]="condition()"
      [showOutcome]="showOutcome()"
      [valueIsComputed]="outputIsComputed()"
      [result]="output()"
      [error]="error()"
      [showAiActions]="false"
      class="grow"
    />
  </ng-container>
</flx-test-modal>
